import {
  store,
} from '../../store/store';

const getIsInAppPurchaseActive = () => store.state.subscription.isInAppPurchaseActive;

export {
  getIsInAppPurchaseActive,
};
